import React from "react"

/**
 * IconBG component
 * @param {Object} props - The properties for the IconBG component.
 * @param {'start'|'mid'|'end'} props.type - The type of background shape for the step icon. Options: 'start', 'mid', 'end'.
 * @returns {React.JSX.Element}
 */
const IconBG = ({ type }) => {
  const types = {
    start: "m121.584 1.97-.286-.511H1.497v57.835h119.805l.285-.516 15.538-28.11.269-.487-.272-.486L121.584 1.97Z",
    mid: "m123.801 1.976-.286-.517H2.258l.827 1.486L18.28 30.264 3.083 57.81l-.818 1.483H123.513l.286-.514 15.466-27.803.269-.484-.268-.485-15.465-28.032Z",
    end: "M139.5 2.459v-1H2.368l.826 1.486L18.39 30.264 3.192 57.81l-.818 1.483H139.5V2.459Z",
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={141}
      height={61}
      fill="none"
    >
      <path
        stroke="#fff"
        strokeWidth={2}
        d={types[type]}
      />
    </svg>
  )


}

/**
 * BlockStep component
 * @param {Object} props - The properties for the BlockStep component.
 * @param {Step} props.step - The step object containing number, color, icon, text, and boxType for the step.
 * @returns {React.JSX.Element}
 */
const BlockStep = ({ step }) => {
  const { color, number, text, boxType = 'mid', icon } = step
  return (
    <div className={`blockSteps-step ${color}`}>
      <div className="blockSteps-step-title"
      >STEP
      </div>
      <div className="blockSteps-step-number">
        {number}
      </div>
      <div className="blockSteps-step-box">
        <img src={icon} alt={text} />
        <IconBG type={boxType} />
      </div>
      <div className="blockSteps-step-text">
        {text}
      </div>

    </div>

  )


}

export default BlockStep